var _rect, _rect2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaPlanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 10,
    fill: "url(#paint0_linear_14_11111)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.11133,
    y: 3.11108,
    width: 63.7778,
    height: 63.7778,
    rx: 10,
    fill: "#FF4D49"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14_11111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7145 46V30.9042L26.8319 42.1451H24.3431L18.4605 30.9042V46H14V23H18.7837L25.5713 36.0873L32.4236 23H37.175V46H32.7145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9662 46V23H51.6952C52.751 23 53.7207 23.216 54.6042 23.6479C55.4877 24.0798 56.2526 24.6629 56.8991 25.3972C57.567 26.1315 58.0842 26.9521 58.4505 27.8592C58.8168 28.7662 59 29.6948 59 30.6451C59 31.9408 58.6983 33.1718 58.095 34.338C57.4916 35.5042 56.662 36.4545 55.6062 37.1887C54.5503 37.923 53.3005 38.2901 51.8568 38.2901H46.4267V46H41.9662ZM46.4267 34.3704H51.5982C52.1369 34.3704 52.6218 34.2192 53.0527 33.9169C53.4837 33.6146 53.8285 33.1826 54.087 32.6211C54.3456 32.038 54.4749 31.3793 54.4749 30.6451C54.4749 29.846 54.3241 29.1657 54.0224 28.6042C53.7423 28.0427 53.3652 27.6216 52.8911 27.3408C52.4386 27.0601 51.943 26.9197 51.4043 26.9197H46.4267V34.3704Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14_11111",
    x: 8,
    y: 21,
    width: 57,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14_11111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14_11111",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_11111",
    x1: 67.2778,
    y1: 1.55555,
    x2: 1.55555,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D49",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaPlanner);
export default __webpack_public_path__ + "static/media/media_planner.a30a4cc2842ad7089f02b7df372b5b2f.svg";
export { ForwardRef as ReactComponent };